var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramLock64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Lock64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(12.000000, 5.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    fill: "#FFFFFF",
    x: 0,
    y: 21,
    width: 40,
    height: 33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,48 L38,48",
    id: "Base-plate",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,20 L31,11 C31,4.92486775 26.0751322,0 20,0 C13.9248678,0 9,4.92486775 9,11 L9,20",
    id: "Lock",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Key-hole",
    transform: "translate(15.000000, 27.990891)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Focus",
    fill: "#FFCC00",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,11 L5,15.0091091",
    id: "slot",
    strokeLinecap: "square"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramLock64);
export default __webpack_public_path__ + "static/media/pictogramLock64.1b7a67413db61d29d8f0c9bae4a09c5f.svg";
export { ForwardRef as ReactComponent };